import { render, staticRenderFns } from "./SARepoSelect.vue?vue&type=template&id=5c329f5b"
import script from "./SARepoSelect.vue?vue&type=script&lang=js"
export * from "./SARepoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports